import TiiDisplay, { TiiDisplayProps } from "components/TiiDisplay/TiiDisplay";
import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useState } from "react";
import styles from "./CoinTiiDisplay.module.scss";
import { useInView } from "react-intersection-observer";
import classNames from "classnames";

export const TiiBubble = (props: TiiDisplayProps & { onClick?(): any }) => {
  const { className, onClick, ...remaining } = props;

  const bubbleSizeClass =
    props.size === "sm"
      ? styles.TiiBubble__sm
      : props.size === "md"
      ? styles.TiiBubble__md
      : props.size === "lg"
      ? styles.TiiBubble__lg
      : styles.TiiBubble__md;

  return (
    <div
      onClick={onClick}
      className={classNames([
        styles.TiiBubble,
        // bubbleSizeClass,
        className,
        remaining.type === "light" && styles.TiiBubble__light,
      ])}
    >
      <TiiDisplay {...remaining} />
    </div>
  );
};

interface Props {}

const CoinTiiDisplay = (props: Props) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    // if (inView && !hasAnimated) {
    if (inView) {
      controls.start("visible");
      setHasAnimated(true);
    }
  }, [inView, controls, hasAnimated]);

  const leftOptions = ["CUBS", "PACK", "BUCS", "LA", "MIA", "CHI"];
  const rightOptions = ["ROCK", "JLO", "KD", "DOGE", "ELON", "ETH"];

  const pickBetween = (first: number, second: number) => {
    return Math.random() * (second - first) + first;
  };

  return (
    <>
      {/* <Media lessThan="md"> */}
      <div className={styles.CoinTiiDisplay} ref={ref}>
        <div
          className={classNames(
            styles.CoinTiiDisplay__col,
            styles.CoinTiiDisplay__col__left
          )}
        >
          {leftOptions.map((o, i) => (
            <div
              key={`left-option-${o}`}
              className={styles.CoinTiiDisplay__animationChamber}
            >
              <motion.div
                initial="hidden"
                animate={controls}
                transition={{
                  type: "spring",
                  stiffness: 50,
                  delay: pickBetween(0, 1),
                }}
                variants={{
                  hidden: {
                    position: "absolute",
                    left: `${i % 2 == 0 ? "-" : ""}400%`,
                  },
                  visible: {
                    position: "absolute",
                    left: `${pickBetween(
                      i % 2 == 0 ? 10 : 40,
                      i % 2 == 0 ? 40 : 70
                    )}%`,
                  },
                }}
              >
                <TiiBubble size="xs" text={o} type="dark" />
              </motion.div>
            </div>
          ))}
        </div>
        <div
          className={classNames(
            styles.CoinTiiDisplay__col,
            styles.CoinTiiDisplay__col__right
          )}
        >
          {rightOptions.map((o, i) => (
            <div className={styles.CoinTiiDisplay__animationChamber}>
              <motion.div
                key={`right-option-${o}`}
                initial="hidden"
                animate={controls}
                transition={{
                  type: "spring",
                  stiffness: 50,
                  delay: pickBetween(0, 1),
                }}
                variants={{
                  hidden: {
                    position: "absolute",
                    left: `${i % 2 == 0 ? "-" : ""}400%`,
                  },
                  visible: {
                    position: "absolute",
                    left: `${pickBetween(
                      i % 2 == 0 ? 10 : 40,
                      i % 2 == 0 ? 40 : 70
                    )}%`,
                  },
                  // visible: { translateX: `180px` },
                }}
              >
                <TiiBubble size="xs" text={o} type="dark" />
              </motion.div>
            </div>
          ))}
        </div>
      </div>
      {/* </Media> */}
      {/* <Media greaterThanOrEqual="md">
        <div className="CoinTiiDisplay" ref={ref}>
          <div className="CoinTiiDisplay__col CoinTiiDisplay__col--left">
            {leftOptions.map((o, i) => (
              <div className="CoinTiiDisplay__animationChamber">
                <motion.div
                  key={`left-option-${o}`}
                  initial="hidden"
                  animate={controls}
                  transition={{
                    type: "spring",
                    stiffness: 50,
                    delay: pickBetween(0, 1),
                  }}
                  variants={{
                    hidden: { position: "absolute", left: "-200%" },
                    visible: {
                      position: "absolute",
                      left: `${pickBetween(
                        i % 2 == 0 ? 30 : 10,
                        i % 2 == 0 ? 50 : 30
                      )}%`,
                    },
                  }}
                >
                  <TiiBubble size="sm" text={o} type="dark" />
                </motion.div>
              </div>
            ))}
          </div>
          <div className="CoinTiiDisplay__col CoinTiiDisplay__col--right">
            {rightOptions.map((o, i) => (
              <div className="CoinTiiDisplay__animationChamber">
                <motion.div
                  key={`right-option-${o}`}
                  initial="hidden"
                  animate={controls}
                  transition={{
                    type: "spring",
                    stiffness: 50,
                    delay: pickBetween(0, 1),
                  }}
                  variants={{
                    hidden: { position: "absolute", left: "200%" },
                    visible: {
                      position: "absolute",
                      left: `${pickBetween(
                        i % 2 == 0 ? 10 : 30,
                        i % 2 == 0 ? 30 : 50
                      )}%`,
                    },
                    // visible: { translateX: `180px` },
                  }}
                >
                  <TiiBubble size="sm" text={o} type="dark" />
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </Media> */}
    </>
  );
};

export default CoinTiiDisplay;
